import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import QRCode from 'qrcode.react';

import Box from '../box/box.jsx';
import styles from './finish-homework.css';

import BackgrdQrcode from './backgrd--qrcode.svg';
import BackgrdTitle from './backgrd--title.svg';
import {closeFinishHomeworkLayer} from '../../reducers/modals';

const FinishHomework = props => (
    <Box className={styles.wrapper}>
        <Box className={styles.detailArea}>
            <div className={styles.qrcodeArea}>
                <img src={BackgrdQrcode} />
                <div>
                    {BackgrdQrcode ? <QRCode
                        size={160}
                        value={props.qrocdeUrl}
                    /> : null}
                </div>
            </div>
            <div className={styles.titleArea}>
                <img src={BackgrdTitle} />
                <span>{'作业提交成功'}</span>
            </div>
            <div className={styles.desArea}>
                <span>{'稍后，老师将点评你的作业，微信扫描二维码，和朋友们分享乐趣'}</span>
            </div>
            <div
                className={styles.btnOk}
                onClick={props.onRequestClose}
            >
                <span>{'好的'}</span>
            </div>
            <div
                className={styles.btnClose}
                onClick={props.onRequestClose}
            >
                <span className={styles.btnOkText}>{'×'}</span>
            </div>
        </Box>
    </Box>
);

FinishHomework.propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    qrocdeUrl: PropTypes.string
};


const mapStateToProps = state => ({
    qrocdeUrl: state.scratchGui.modals.homeworkQrcodeUrl
});

const mapDispatchToProps = dispatch => ({
    onRequestClose: () => dispatch(closeFinishHomeworkLayer())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FinishHomework);
